namespace TabAurous.ProductDevelopment {
    export interface SpecSheetItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        DesignName: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        DepartmentId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        ExportPieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        Parts: Serenity.IntegerEditor;
        PureWeight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        UnitRate: Serenity.DecimalEditor;
        MetalAmount: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        StoneAmount: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: Serenity.DecimalEditor;
        OtherRate: AmountEditor;
        OtherAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        MF: Serenity.DecimalEditor;
        MFAmount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: Serenity.DecimalEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        Image4: Serenity.ImageUploadEditor;
        Image5: Serenity.ImageUploadEditor;
        Image6: Serenity.ImageUploadEditor;
        Image7: Serenity.ImageUploadEditor;
        Image8: Serenity.ImageUploadEditor;
        Video1: Serenity.ImageUploadEditor;
        Video2: Serenity.ImageUploadEditor;
        BOMDetails: SpecSheetBOMEditor;
        LaborDetails: SpecSheetLaborEditor;
        Studded: Serenity.IntegerEditor;
    }

    export class SpecSheetItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.SpecSheetItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SpecSheetItemsForm.init)  {
                SpecSheetItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = CommonProductSizeLookup;
                var w6 = s.BooleanEditor;
                var w7 = s.DecimalEditor;
                var w8 = StoneSizeLookup;
                var w9 = StoneSieveLookup;
                var w10 = AmountEditor;
                var w11 = s.DateEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = SpecSheetBOMEditor;
                var w14 = SpecSheetLaborEditor;

                Q.initFormType(SpecSheetItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'DesignName', w0,
                    'DesignId', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'StampId', w2,
                    'ProductSizeId', w5,
                    'HasBom', w6,
                    'MetalId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w7,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w8,
                    'SieveId', w9,
                    'GroupSieveId', w9,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'DepartmentId', w1,
                    'Line_No', w0,
                    'RefNo', w0,
                    'Pieces', w1,
                    'ExportPieces', w1,
                    'Weight', w7,
                    'Parts', w1,
                    'PureWeight', w7,
                    'NetWeight', w7,
                    'UnitRate', w7,
                    'MetalAmount', w7,
                    'StonePieces', w1,
                    'StoneWeight', w7,
                    'StoneRate', w10,
                    'StoneAmount', w7,
                    'DiamondPieces', w1,
                    'DiamondWeight', w7,
                    'DiamondAmount', w7,
                    'OtherPieces', w1,
                    'OtherWeight', w7,
                    'OtherRate', w10,
                    'OtherAmount', w7,
                    'NetAmount', w7,
                    'UnitLabour', w7,
                    'FancyCharges', w10,
                    'OtherCharges', w10,
                    'GrossAmount', w7,
                    'CCGrossAmount', w7,
                    'CCNetAmount', w7,
                    'MF', w7,
                    'MFAmount', w7,
                    'UnitCost', w7,
                    'DiscountPer', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w7,
                    'Remarks', w0,
                    'IsDisabled', w6,
                    'ServerDate', w11,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w11,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w12,
                    'Image1', w12,
                    'Image2', w12,
                    'Image3', w12,
                    'Image4', w12,
                    'Image5', w12,
                    'Image6', w12,
                    'Image7', w12,
                    'Image8', w12,
                    'Video1', w12,
                    'Video2', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14,
                    'Studded', w1
                ]);
            }
        }
    }
}
